import React from 'react';
import { HelpPopover } from '@gravity-ui/components';
import { ChevronDown } from '@gravity-ui/icons';
import { ActionTooltip, Button, Hotkey, Icon, Menu, Popover, Popup } from '@gravity-ui/uikit';
import { cn } from '../classname';
import { i18n } from '../i18n/common';
import { isFunction } from '../lodash';
import { useBooleanState } from '../react-utils/hooks';
import { ToolbarTooltipDelay } from './const';
import './ToolbarListButton.css';
const b = cn('toolbar-list-button');
export function ToolbarListButton({ className, editor, focus, onClick, icon, title, withArrow, data, alwaysActive, }) {
    var _a;
    const buttonRef = React.useRef(null);
    const [open, , hide, toggleOpen] = useBooleanState(false);
    const someActive = alwaysActive
        ? false
        : data.some((item) => item.isActive(editor) && !item.doNotActivateList);
    const everyDisabled = alwaysActive ? false : data.every((item) => !item.isEnable(editor));
    const popupOpen = everyDisabled ? false : open;
    const shouldForceHide = open && !popupOpen;
    React.useEffect(() => {
        if (shouldForceHide) {
            hide();
        }
    }, [hide, shouldForceHide]);
    if (data.length === 0)
        return null;
    const buttonContent = [React.createElement(Icon, { key: 1, data: icon.data, size: (_a = icon.size) !== null && _a !== void 0 ? _a : 16 })];
    if (withArrow) {
        buttonContent.push(React.createElement(React.Fragment, { key: 2 }, ''));
        buttonContent.push(React.createElement(Icon, { key: 3, data: ChevronDown, size: 16 }));
    }
    const titleText = isFunction(title) ? title() : title;
    return (React.createElement(React.Fragment, null,
        React.createElement(Popover, { className: b('action-disabled-popover'), tooltipContentClassName: b('action-disabled-tooltip'), content: i18n('toolbar_action_disabled'), placement: 'bottom', disabled: !everyDisabled },
            React.createElement(ActionTooltip, { title: titleText, disabled: popupOpen, openDelay: ToolbarTooltipDelay.Open, closeDelay: ToolbarTooltipDelay.Close },
                React.createElement(Button, { size: "m", ref: buttonRef, view: someActive || popupOpen ? 'normal' : 'flat', selected: someActive, disabled: everyDisabled, className: b({ arrow: withArrow }, [className]), onClick: toggleOpen }, buttonContent))),
        React.createElement(Popup, { anchorRef: buttonRef, open: popupOpen, onClose: hide },
            React.createElement(Menu, { size: "l", className: b('menu') }, data
                .map((data) => {
                var _a;
                const { id, title, icon, hotkey, isActive, isEnable, exec, hint, hintWhenDisabled, disabledPopoverVisible = true, } = data;
                const titleText = isFunction(title) ? title() : title;
                const hintText = isFunction(hint) ? hint() : hint;
                const disabled = !isEnable(editor);
                const hideHintWhenDisabled = hintWhenDisabled === false || !disabledPopoverVisible || !disabled;
                const hintWhenDisabledText = typeof hintWhenDisabled === 'string'
                    ? hintWhenDisabled
                    : typeof hintWhenDisabled === 'function'
                        ? hintWhenDisabled()
                        : i18n('toolbar_action_disabled');
                return (React.createElement(Popover, { className: b('action-disabled-popover'), tooltipContentClassName: b('action-disabled-tooltip'), content: hintWhenDisabledText, placement: 'left', disabled: hideHintWhenDisabled, key: id },
                    React.createElement(Menu.Item, { key: id, active: isActive(editor), disabled: !isEnable(editor), onClick: () => {
                            hide();
                            focus();
                            exec(editor);
                            onClick === null || onClick === void 0 ? void 0 : onClick(id);
                        }, icon: React.createElement(Icon, { data: icon.data, size: (_a = icon.size) !== null && _a !== void 0 ? _a : 16 }), extraProps: { 'aria-label': titleText } },
                        React.createElement("div", { className: b('item') },
                            titleText,
                            React.createElement("div", { className: b('extra') },
                                hotkey && React.createElement(Hotkey, { value: hotkey }),
                                hintText && (React.createElement(HelpPopover, { className: b('hint'), content: hintText })))))));
            })
                .filter(Boolean)))));
}
